import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Package } from 'lucide-react';
import { KpiGrid, SectionHeader, ExportButtons, ReportTable, fIDR, fIDRCompact } from './shared';

export function ProductsTab({ data, loading, filters }) {
  const s = data?.summary || {};
  const cards = [
    { label: 'Total Produk Dipakai', value: s.total_product_used || 0, accent: 'primary' },
    { label: 'Total Paket Dipakai', value: s.total_package_used || 0, accent: 'primary' },
    { label: 'Revenue Produk', value: fIDRCompact(s.total_revenue_product), accent: 'success' },
    { label: 'Revenue Paket', value: fIDRCompact(s.total_revenue_package), accent: 'success' },
    { label: 'Top Produk Revenue', value: s.top_product ? s.top_product.name : '—', sub: s.top_product ? fIDRCompact(s.top_product.revenue) : '' },
    { label: 'Top Paket Closing', value: s.top_package ? s.top_package.name : '—', sub: s.top_package ? `${s.top_package.invoice_count}x closing` : '' },
  ];
  const products = data?.products || [];
  const packages = data?.packages || [];
  return (
    <div className="space-y-4">
      <SectionHeader icon={Package} title="Laporan Produk & Paket" action={<ExportButtons tab="products_packages" filters={filters} />} />
      <KpiGrid items={cards} loading={loading} columns={3} />

      <Card className="bg-card border-border">
        <CardHeader className="pb-2"><CardTitle className="text-sm text-slate-100">Detail Produk ({products.length})</CardTitle></CardHeader>
        <CardContent className="p-0 sm:p-4">
          <ReportTable
            getRowKey={(r) => r.id}
            columns={[
              { key: 'name', label: 'Produk', render: r => <span className="font-medium text-slate-100">{r.name}</span> },
              { key: 'category', label: 'Kategori', render: r => <span className="text-xs text-slate-300">{r.category || '—'}</span> },
              { key: 'quotation_count', label: 'Di Penawaran', align: 'right', render: r => <span className="text-slate-200">{r.quotation_count}</span> },
              { key: 'invoice_count', label: 'Closing', align: 'right', render: r => <span className="text-slate-200">{r.invoice_count}</span> },
              { key: 'revenue', label: 'Revenue', align: 'right', render: r => <span className="font-mono-num text-slate-100">{fIDR(r.revenue)}</span> },
              { key: 'qty_sum', label: 'Qty', align: 'right', render: r => <span className="text-slate-300">{r.qty_sum}</span> },
              { key: 'average_price', label: 'Avg Price', align: 'right', render: r => <span className="font-mono-num text-slate-300">{fIDR(r.average_price)}</span> },
              { key: 'is_active', label: 'Status', render: r => <span className={`text-xs ${r.is_active ? 'text-emerald-300' : 'text-slate-400'}`}>{r.is_active ? 'Aktif' : 'Non-Aktif'}</span> },
            ]}
            rows={products}
            emptyText="Belum ada data produk pada periode ini."
            mobileCard={(r) => (
              <div className="text-sm space-y-1">
                <div className="font-semibold text-slate-100">{r.name}</div>
                <div className="text-xs text-slate-300">{r.category || '—'}</div>
                <div className="grid grid-cols-2 gap-1 text-xs text-slate-300 mt-2">
                  <div>Penawaran: {r.quotation_count}</div>
                  <div>Closing: {r.invoice_count}</div>
                  <div>Qty: {r.qty_sum}</div>
                  <div>Avg: <span className="font-mono-num text-slate-200">{fIDR(r.average_price)}</span></div>
                </div>
                <div className="font-mono-num font-semibold text-slate-100 mt-1">{fIDR(r.revenue)}</div>
              </div>
            )}
          />
        </CardContent>
      </Card>

      <Card className="bg-card border-border">
        <CardHeader className="pb-2"><CardTitle className="text-sm text-slate-100">Detail Paket ({packages.length})</CardTitle></CardHeader>
        <CardContent className="p-0 sm:p-4">
          <ReportTable
            getRowKey={(r) => `pkg-${r.id}`}
            columns={[
              { key: 'name', label: 'Paket', render: r => <span className="font-medium text-slate-100">{r.name}</span> },
              { key: 'category', label: 'Kategori', render: r => <span className="text-xs text-slate-300">{r.category || '—'}</span> },
              { key: 'quotation_count', label: 'Di Penawaran', align: 'right', render: r => <span className="text-slate-200">{r.quotation_count}</span> },
              { key: 'invoice_count', label: 'Closing', align: 'right', render: r => <span className="text-slate-200">{r.invoice_count}</span> },
              { key: 'revenue', label: 'Revenue', align: 'right', render: r => <span className="font-mono-num text-slate-100">{fIDR(r.revenue)}</span> },
              { key: 'average_price', label: 'Avg Price', align: 'right', render: r => <span className="font-mono-num text-slate-300">{fIDR(r.average_price)}</span> },
              { key: 'is_active', label: 'Status', render: r => <span className={`text-xs ${r.is_active ? 'text-emerald-300' : 'text-slate-400'}`}>{r.is_active ? 'Aktif' : 'Non-Aktif'}</span> },
            ]}
            rows={packages}
            emptyText="Belum ada data paket pada periode ini."
            mobileCard={(r) => (
              <div className="text-sm space-y-1">
                <div className="font-semibold text-slate-100">{r.name}</div>
                <div className="text-xs text-slate-300">{r.category || '—'}</div>
                <div className="grid grid-cols-2 gap-1 text-xs text-slate-300 mt-2">
                  <div>Penawaran: {r.quotation_count}</div>
                  <div>Closing: {r.invoice_count}</div>
                </div>
                <div className="font-mono-num font-semibold text-slate-100 mt-1">{fIDR(r.revenue)}</div>
              </div>
            )}
          />
        </CardContent>
      </Card>
    </div>
  );
}
